<script>
	export let id = null;
	export let name = null;
	export let label = null;
	export let sublabel = null;
	export let value = null;
	export let maxlength = null;
	export let placeholder = null;
	export let rows = 3;
	export let required = null;
	export let disabled = null;
</script>

{#if label}
	<label for={id}>
		{label}

		{#if required}
			<span class="required">*</span>
		{/if}

		{#if sublabel}
			<div class="sublabel">{sublabel}</div>
		{/if}
	</label>
{/if}
{#if !disabled}
	<textarea {required} {id} {name} {maxlength} {rows} {placeholder} bind:value class="form-control" />
{:else}
	<div {id}>{value}</div>
{/if}

<style>
	textarea {
		height: auto;
	}

	div {
		background-color: #fff;
		opacity: 1;
		height: auto;
		appearance: none;
		border: solid 1px var(--color-soft);
		border-radius: 1px;
		padding: var(--spacing-sm);
		font-size: 18px;
		line-height: 26px;
		color: var(--color-body);
		white-space: pre-wrap;
	}
</style>
